/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";

import { apiToken, apiUrl } from "./constants";

// get admin users
export async function userLogin(email, password) {
    if ((email, password)) {
        const users = await axios.post(
            apiUrl + "login",
            {
                email,
                password,
            },
            {
                headers: {
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            }
        );
        return users;
    } else {
        console.log("Please add required parameters");
    }
}
